import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters(['authentication_user']),
        ...mapState({
            filters: state => state.filters.filters
        }),
        productList() {
            return this.$store.state[this.storeModule][this.storeKey].data;
        },
        totalProducts() {
            return this.$store.state[this.storeModule][this.storeKey].count;
        },
        hasNextPage() {
            return this.$store.state[this.storeModule][this.storeKey].next !== null;
        },
        currentPage() {
            return this.$store.state[this.storeModule][this.storeKey].current_page || 1;
        },
        pageSize() {
            return this.$store.state[this.storeModule][this.storeKey].page_size || 25;
        },
        paginationTotalPages() {
            const count = this.$store.state[this.storeModule][this.storeKey].count || 0;
            const size = this.pageSize;
            return Math.max(1, Math.ceil(count / size));
        },
    },
    data() {
        return {
            loading: true,
            url: '',
            search_product: '',
            search_type: 'codigo',
            storeModule: 'product',
            storeKey: 'data',
            mutationName: 'product_list',
            _abortController: null,
        };
    },
    watch: {
        loading(newVal) {
            if (!newVal) {
                this.$emit('loaded');
            }
        },
        filters: {
            handler() {
                this.fetchData();
            },
            deep: true
        },
        'authentication_user.client_business_select'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loading = false;
                this.fetchData();
            }
        }
    },
    created() {
        this.fetchData();
    },
    beforeDestroy() {
        if (this._abortController) {
            this._abortController.abort();
        }
    },
    methods: {
        ...mapActions(['get']),
        fetchData(url) {
            if (this._abortController) {
                this._abortController.abort();
            }
            this._abortController = new AbortController();

            if (url) {
                this.url = url;
            } else {
                this.url = this.buildUrl();
            }
            this.loading = true;
            this.get({
                url: this.url,
                mutation: this.mutationName,
                signal: this._abortController.signal,
            }).then(() => {
                this.loading = false;
            }).catch((error) => {
                if (error && error.name === 'AbortError') return;
                this.loading = false;
                if (error.status == 403) {
                    this.$router.push('*');
                }
            });
        },
        getSearch(search_product, search_type) {
            this.search_product = search_product;
            this.search_type = search_type;
            this.fetchData();
        },
        buildCommonParams() {
            const f = this.filters;
            let params = `page_size=25&search=${encodeURIComponent(this.search_product)}&search_type=${encodeURIComponent(this.search_type)}&prop_extra_1=${encodeURIComponent(f.supplier || '')}&prop_extra_5=${encodeURIComponent(f.brand || '')}&prop_extra_2=${encodeURIComponent(f.product_type || '')}&prop_extra_3=${encodeURIComponent(f.product_status || '')}&prop_extra_4=${encodeURIComponent(f.product_group || '')}`;
            if (f.select_category != null) {
                params += `&categoryproduct=${f.select_category}`;
            }
            if (!this.authentication_user.client_channel) {
                params += `&business=${this.authentication_user.client_business_select}`;
            }
            if (this.authentication_user.active_store) {
                params += `&cluster=${f.cluster || ''}`;
            }
            return params;
        },
        buildUrlWithPage(baseUrl, page, pageSize) {
            let url = baseUrl.replace(/&?page=\d+/g, '').replace(/&?page_size=\d+/g, '');
            if (url.endsWith('&') || url.endsWith('?')) {
                url = url.slice(0, -1);
            }
            const hasQuery = url.includes('?');
            const conn = hasQuery ? '&' : '?';
            url += `${conn}page=${page}&page_size=${pageSize || 25}`;
            return url;
        },
        changePage(page) {
            if (page < 1 || page > this.paginationTotalPages) return;
            const url = this.buildUrlWithPage(this.url, page, this.pageSize);
            this.fetchData(url);
        },
        changePageSize(newSize) {
            const url = this.buildUrlWithPage(this.url, 1, newSize);
            this.fetchData(url);
        },
    }
};
